export default "__VITE_ASSET__e1626326__"